import { put, takeLatest } from 'redux-saga/effects';
import { signup, signin, success, failed } from '../slice/userSlice';
import { postRequest, getRequest, deleteRequest, patchRequest } from './ApiInstence';
import { toast } from 'react-toastify';
import { getContactUs, successContactUs, failedContactUs, removeContactUs, getDashboardData } from '../slice/contactUsSlice';
import { getAppointment, successAppointment, failedAppointment, removeAppointment ,getDashboardDataa} from '../slice/appointmentSlice';
import { getEnquire, successEnquire, failedEnquire, removeEnquire } from '../slice/enquireSlice';
import { addProduct, getProduct, updateProduct, successProduct, failedProduct, removeProduct, getOneProduct, searchProductByName } from '../slice/productSlice';
import { getGallery, successGallery, removeGallery, addGallery, updateGallery, getOneGallery } from '../slice/gallerySlice';
import { getMedia, successMedia, removeMedia, addMedia, updateMedia, getOneMedia } from '../slice/mediaSlice';
import {
  addReelVideo,
  failedReelVideo,
  getOneReelVideo,
  getReelVideo,
  removeReelVideo,
  successOneReelVideo,
  successReelVideo,
  updateReelVideo,
} from '../slice/reelVideoSlice';
import {
  addTextTestimonial,
  failedTextTestimonial,
  getOneTextTestimonial,
  getTextTestimonial,
  removeTextTestimonial,
  successOneTextTestimonial,
  successTextTestimonial,
  updateTextTestimonial,
} from '../slice/textTestimonialSlice';
import { getBanner, successBanner, removeBanner, addBanner, updateBanner, getOneBanner } from '../slice/bannerSlice';
import { failedCareer, getCareer, removeCareer, successCareer } from 'slice/careerSlice';
import { getOurteam, successOurteam, removeOurteam, addOurteam, updateOurteam, getOneOurteam, failedOurteam } from 'slice/ourteamSlice';
import { getCustomer, successCustomer, removeCustomer, addCustomer, updateCustomer, getOneCustomer, searchByMobile } from '../slice/customerSlice';
import {
  addMedicine,
  failedMedicine,
  getMedicine,
  getOneMedicine,
  removeMedicine,
  successMedicine,
  successOneMedicine,
  updateMedicine,
} from '../slice/medicineSlice';
import {
  addPlan,
  failedPlan,
  getPlan,
  getOnePlan,
  removePlan,
  successPlan,
  successOnePlan,
  updatePlan,
} from '../slice/planSlice';
import {
  addPlanMedicine,
  failedPlanMedicine,
  getPlanMedicine,
  getOnePlanMedicine,
  removePlanMedicine,
  successPlanMedicine,
  successOnePlanMedicine,
  updatePlanMedicine,
} from '../slice/planMedicineSlice';
import { addOrderListDB, getOrderListDB, getOrderDeatilsDB, successOrderListDB, failedOrderListDB, updateOrderListDB } from '../slice/orderSliceDB';
import { updateOrderAPI } from './orderAPI/orderAPI';

const multipartFormHeaders = {
  headers: {
    'Content-Type': 'multipart/form-data',
  },
};

const getErrorMessage = (error, fallbackMessage) =>
  error?.response?.data?.message || error?.data?.message || error?.message || fallbackMessage;


// Generator function
function* signinUser({ payload }) {
  try {
    // You can also export the axios call as a function.
    let response = yield postRequest('admin/signin', payload, {
      withCredentials: true, // Include cookies in the request
    });
    if (response == undefined) {
      response = {
        message: 'something wrong try after sometime'
      }
    }
    if (response?.status == 200) {
      yield put(success(response));
    } else {
      yield put(failed(response));
    }
  } catch (error) {
    yield put(failed(error));
  }
}

function* signupUser({ payload }) {
  try {
    const response = yield postRequest('register', payload);
    if (response?.status == 200) {
      yield put(success(response?.data));
    } else {
      yield put(failed(response));
    }
  } catch (error) {
    console.log(error)
    toast('resposnse.message')
  }
}

function* getContactUsFun({ payload }) {
  try {
    const response = yield getRequest('contactus', payload);
    if (response?.status == 200) {
      yield put(successContactUs(response?.data));
    } else {
      yield put(failedContactUs(response));
    }
  } catch (error) {
    console.log(error)
    toast('resposnse.message')
  }
}

function* getDashboardDataFun({ payload }) {
  try {
    const response = yield getRequest('dashboard', payload);
    if (response?.status == 200) {
      yield put(successContactUs(response?.data));
    } else {
      yield put(failedContactUs(response));
    }
  } catch (error) {
    console.log(error)
    toast('resposnse.message')
  }
}


function* getProductFun() {
  try {
    const response = yield getRequest('product');
    if (response?.status == 200) {
      yield put(successProduct(response?.data));
    } else {
      yield put(failedProduct(response));
    }
  } catch (error) {
    console.log(error)
    toast('resposnse.message')
    yield put(failedProduct(error));
  }
}

function* getOneProductFun({ payload }) {
  try {
    const response = yield getRequest(`product/one/${payload}`);
    if (response?.status == 200) {
      yield put(successProduct(response?.data));
    } else {
      yield put(failedProduct(response));
    }
  } catch (error) {
    console.log(error)
    toast('resposnse.message')
    yield put(failedProduct(error));
  }
}

function* removeContactUsFun({ payload }) {
  try {
    const response = yield deleteRequest(`contactus/${payload}`);
    if (response?.status == 200) {
      const response = yield getRequest('contactus', payload);
      yield put(successContactUs(response?.data));
    } else {
      yield put(failedContactUs(response));
    }
  } catch (error) {
    console.log(error)
    toast('resposnse.message')
  }
}

function* removeProductFun({ payload }) {
  try {
    const response = yield deleteRequest(`product/${payload}`);
    if (response?.status == 200) {
      const response = yield getRequest('product', payload);
      yield put(successProduct(response?.data));
    } else {
      yield put(failedProduct(response));
    }
  } catch (error) {
    console.log(error)
    toast('resposnse.message')
    yield put(failedProduct(error));
  }
}

function* addProductFun({ payload }) {
  try {
    const response = yield postRequest(`product`, payload);
    if (response?.status >= 200 && response?.status < 300) {
      yield put(successProduct(response?.data));
    } else {
      yield put(failedProduct(response));
    }
  } catch (error) {
    console.log(error)
    toast('resposnse.message')
    yield put(failedProduct(error));
  }
}

function* searchProductByNameFun({ payload }) {
  try {
    const query = typeof payload === 'string' ? payload.trim() : '';
    const endpoint = query ? `product/search?product=${encodeURIComponent(query)}` : 'product';
    const response = yield getRequest(endpoint);
    if (response?.status == 200) {
      yield put(successProduct(response?.data));
    } else {
      yield put(failedProduct(response));
    }
  } catch (error) {
    console.log(error)
    toast('resposnse.message')
    yield put(failedProduct(error));
  }
}

function* updateProductFun({ payload }) {
  try {
    const response = yield patchRequest(`product/${payload.id}`, payload.data);
    if (response?.status == 200) {
      const refreshedProducts = yield getRequest('product');
      yield put(successProduct(refreshedProducts?.data));
    } else {
      yield put(failedProduct(response));
    }
  } catch (error) {
    console.log(error)
    toast('resposnse.message')
    yield put(failedProduct(error));
  }
}

function* getMedicineFun() {
  try {
    const response = yield getRequest('medicines');
    if (response?.status == 200) {
      yield put(successMedicine(response?.data));
    } else {
      yield put(failedMedicine(response));
    }
  } catch (error) {
    console.log(error);
    yield put(failedMedicine(error));
    toast(getErrorMessage(error, 'Unable to fetch medicines.'));
  }
}

function* getOneMedicineFun({ payload }) {
  try {
    const response = yield getRequest(`medicines/one/${payload}`);
    if (response?.status == 200) {
      yield put(successOneMedicine(response?.data));
    } else {
      yield put(failedMedicine(response));
    }
  } catch (error) {
    console.log(error);
    yield put(failedMedicine(error));
    toast(getErrorMessage(error, 'Unable to fetch medicine details.'));
  }
}

function* addMedicineFun({ payload }) {
  try {
    const response = yield postRequest('medicines', payload);
    if (response?.status >= 200 && response?.status < 300) {
      const refreshedMedicines = yield getRequest('medicines');
      yield put(successMedicine(refreshedMedicines?.status === 200 ? refreshedMedicines?.data : []));
    } else {
      yield put(failedMedicine(response));
      toast(getErrorMessage(response, 'Unable to add medicine.'));
    }
  } catch (error) {
    console.log(error);
    yield put(failedMedicine(error));
    toast(getErrorMessage(error, 'Unable to add medicine.'));
  }
}

function* updateMedicineFun({ payload }) {
  try {
    const response = yield patchRequest(`medicines/${payload.id}`, payload.data);
    if (response?.status == 200) {
      const refreshedMedicines = yield getRequest('medicines');
      yield put(successMedicine(refreshedMedicines?.status === 200 ? refreshedMedicines?.data : []));
    } else {
      yield put(failedMedicine(response));
      toast(getErrorMessage(response, 'Unable to update medicine.'));
    }
  } catch (error) {
    console.log(error);
    yield put(failedMedicine(error));
    toast(getErrorMessage(error, 'Unable to update medicine.'));
  }
}

function* removeMedicineFun({ payload }) {
  try {
    const response = yield deleteRequest(`medicines/${payload}`);
    if (response?.status == 200) {
      const refreshedMedicines = yield getRequest('medicines');
      yield put(successMedicine(refreshedMedicines?.status === 200 ? refreshedMedicines?.data : []));
    } else {
      yield put(failedMedicine(response));
      toast(getErrorMessage(response, 'Unable to delete medicine.'));
    }
  } catch (error) {
    console.log(error);
    yield put(failedMedicine(error));
    toast(getErrorMessage(error, 'Unable to delete medicine.'));
  }
}

function* getPlanFun() {
  try {
    const response = yield getRequest('plans');
    if (response?.status == 200) {
      yield put(successPlan(response?.data));
    } else {
      yield put(failedPlan(response));
    }
  } catch (error) {
    console.log(error);
    yield put(failedPlan(error));
    toast(getErrorMessage(error, 'Unable to fetch plans.'));
  }
}

function* getOnePlanFun({ payload }) {
  try {
    const response = yield getRequest(`plans/one/${payload}`);
    if (response?.status == 200) {
      yield put(successOnePlan(response?.data));
    } else {
      yield put(failedPlan(response));
    }
  } catch (error) {
    console.log(error);
    yield put(failedPlan(error));
    toast(getErrorMessage(error, 'Unable to fetch plan details.'));
  }
}

function* addPlanFun({ payload }) {
  try {
    const response = yield postRequest('plans', payload);
    if (response?.status >= 200 && response?.status < 300) {
      const refreshedPlans = yield getRequest('plans');
      yield put(successPlan(refreshedPlans?.status === 200 ? refreshedPlans?.data : []));
    } else {
      yield put(failedPlan(response));
      toast(getErrorMessage(response, 'Unable to add plan.'));
    }
  } catch (error) {
    console.log(error);
    yield put(failedPlan(error));
    toast(getErrorMessage(error, 'Unable to add plan.'));
  }
}

function* updatePlanFun({ payload }) {
  try {
    const response = yield patchRequest(`plans/${payload.id}`, payload.data);
    if (response?.status == 200) {
      const refreshedPlans = yield getRequest('plans');
      yield put(successPlan(refreshedPlans?.status === 200 ? refreshedPlans?.data : []));
    } else {
      yield put(failedPlan(response));
      toast(getErrorMessage(response, 'Unable to update plan.'));
    }
  } catch (error) {
    console.log(error);
    yield put(failedPlan(error));
    toast(getErrorMessage(error, 'Unable to update plan.'));
  }
}

function* removePlanFun({ payload }) {
  try {
    const response = yield deleteRequest(`plans/${payload}`);
    if (response?.status == 200) {
      const refreshedPlans = yield getRequest('plans');
      yield put(successPlan(refreshedPlans?.status === 200 ? refreshedPlans?.data : []));
    } else {
      yield put(failedPlan(response));
      toast(getErrorMessage(response, 'Unable to delete plan.'));
    }
  } catch (error) {
    console.log(error);
    yield put(failedPlan(error));
    toast(getErrorMessage(error, 'Unable to delete plan.'));
  }
}

function* getPlanMedicineFun() {
  try {
    const response = yield getRequest('plan_medicines');
    if (response?.status == 200) {
      yield put(successPlanMedicine(response?.data));
    } else {
      yield put(failedPlanMedicine(response));
    }
  } catch (error) {
    console.log(error);
    yield put(failedPlanMedicine(error));
    toast(getErrorMessage(error, 'Unable to fetch plan medicines.'));
  }
}

function* getOnePlanMedicineFun({ payload }) {
  try {
    const response = yield getRequest(`plan_medicines/one/${payload}`);
    if (response?.status == 200) {
      yield put(successOnePlanMedicine(response?.data));
    } else {
      yield put(failedPlanMedicine(response));
    }
  } catch (error) {
    console.log(error);
    yield put(failedPlanMedicine(error));
    toast(getErrorMessage(error, 'Unable to fetch plan medicine details.'));
  }
}

function* addPlanMedicineFun({ payload }) {
  try {
    const response = yield postRequest('plan_medicines', payload);
    if (response?.status >= 200 && response?.status < 300) {
      const refreshedPlanMedicines = yield getRequest('plan_medicines');
      yield put(successPlanMedicine(refreshedPlanMedicines?.status === 200 ? refreshedPlanMedicines?.data : []));
    } else {
      yield put(failedPlanMedicine(response));
      toast(getErrorMessage(response, 'Unable to add plan medicine.'));
    }
  } catch (error) {
    console.log(error);
    yield put(failedPlanMedicine(error));
    toast(getErrorMessage(error, 'Unable to add plan medicine.'));
  }
}

function* updatePlanMedicineFun({ payload }) {
  try {
    const response = yield patchRequest(`plan_medicines/${payload.id}`, payload.data);
    if (response?.status == 200) {
      const refreshedPlanMedicines = yield getRequest('plan_medicines');
      yield put(successPlanMedicine(refreshedPlanMedicines?.status === 200 ? refreshedPlanMedicines?.data : []));
    } else {
      yield put(failedPlanMedicine(response));
      toast(getErrorMessage(response, 'Unable to update plan medicine.'));
    }
  } catch (error) {
    console.log(error);
    yield put(failedPlanMedicine(error));
    toast(getErrorMessage(error, 'Unable to update plan medicine.'));
  }
}

function* removePlanMedicineFun({ payload }) {
  try {
    const response = yield deleteRequest(`plan_medicines/${payload}`);
    if (response?.status == 200) {
      const refreshedPlanMedicines = yield getRequest('plan_medicines');
      yield put(successPlanMedicine(refreshedPlanMedicines?.status === 200 ? refreshedPlanMedicines?.data : []));
    } else {
      yield put(failedPlanMedicine(response));
      toast(getErrorMessage(response, 'Unable to delete plan medicine.'));
    }
  } catch (error) {
    console.log(error);
    yield put(failedPlanMedicine(error));
    toast(getErrorMessage(error, 'Unable to delete plan medicine.'));
  }
}

//Gallery Functions 
function* getGalleryFun() {
  try {
    const response = yield getRequest('gallery');
    if (response?.status == 200) {
      yield put(successGallery(response?.data));
    } else {
      yield put(failedContactUs(response));
    }
  } catch (error) {
    console.log(error)
    toast('resposnse.message')
  }
}

function* getOneGalleryFun({ payload }) {
  try {
    const response = yield getRequest(`gallery/one/${payload}`);
    if (response?.status == 200) {
      yield put(successGallery(response?.data));
    } else {
      yield put(failedContactUs(response));
    }
  } catch (error) {
    console.log(error)
    toast('resposnse.message')
  }
}

function* removeGalleryFun({ payload }) {
  try {
    const response = yield deleteRequest(`gallery/${payload}`);
    if (response?.status == 200) {
      const response = yield getRequest('gallery', payload);
      yield put(successGallery(response?.data));
    } else {
      yield put(failedContactUs(response));
    }
  } catch (error) {
    console.log(error)
    toast('resposnse.message')
  }
}

function* addGalleryFun({ payload }) {
  try {
    const response = yield postRequest(`gallery`, payload);
    if (response?.status == 200) {
      yield put(successGallery(response?.data));
    } else {
      yield put(failedContactUs(response));
    }
  } catch (error) {
    console.log(error)
    toast('resposnse.message')
  }
}

function* updateGalleryFun({ payload }) {
  try {
    const response = yield patchRequest(`gallery/${payload.id}`, payload.data);
    if (response?.status == 200) {
      yield put(successGallery(response?.data));
    } else {
      yield put(failedContactUs(response));
    }
  } catch (error) {
    console.log(error)
    toast('resposnse.message')
  }
}
//Media Functions 
function* getMediaFun() {
  try {
    const response = yield getRequest('media');
    if (response?.status == 200) {
      yield put(successMedia(response?.data));
    } else {
      yield put(failedContactUs(response));
    }
  } catch (error) {
    console.log(error)
    toast('resposnse.message')
  }
}

function* getOneMediaFun({ payload }) {
  try {
    const response = yield getRequest(`media/one/${payload}`);
    if (response?.status == 200) {
      yield put(successMedia(response?.data));
    } else {
      yield put(failedContactUs(response));
    }
  } catch (error) {
    console.log(error)
    toast('resposnse.message')
  }
}

function* removeMediaFun({ payload }) {
  try {
    const response = yield deleteRequest(`media/${payload}`);
    if (response?.status == 200) {
      const response = yield getRequest('media', payload);
      yield put(successMedia(response?.data));
    } else {
      yield put(failedContactUs(response));
    }
  } catch (error) {
    console.log(error)
    toast('resposnse.message')
  }
}

function* addMediaFun({ payload }) {
  try {
    const response = yield postRequest(`media`, payload);
    if (response?.status == 200) {
      yield put(successMedia(response?.data));
    } else {
      yield put(failedContactUs(response));
    }
  } catch (error) {
    console.log(error)
    toast('resposnse.message')
  }
}

function* updateMediaFun({ payload }) {
  try {
    const response = yield patchRequest(`media/${payload.id}`, payload.data);
    if (response?.status == 200) {
      yield put(successMedia(response?.data));
    } else {
      yield put(failedContactUs(response));
    }
  } catch (error) {
    console.log(error)
    toast('resposnse.message')
  }
}

// Reel Video Functions
function* getReelVideoFun() {
  try {
    const response = yield getRequest('video_reels/admin/all');
    if (response?.status == 200) {
      yield put(successReelVideo({ data: response?.data, action: 'fetchList' }));
    } else {
      yield put(failedReelVideo(response));
    }
  } catch (error) {
    console.log(error);
    yield put(failedReelVideo(error));
    toast(getErrorMessage(error, 'Unable to fetch reel videos.'));
  }
}

function* getOneReelVideoFun({ payload }) {
  try {
    const response = yield getRequest(`video_reels/one/${payload}`);
    if (response?.status == 200) {
      yield put(successOneReelVideo({ data: response?.data, action: 'fetchOne' }));
    } else {
      yield put(failedReelVideo(response));
    }
  } catch (error) {
    console.log(error);
    yield put(failedReelVideo(error));
    toast(getErrorMessage(error, 'Unable to fetch reel video details.'));
  }
}

function* addReelVideoFun({ payload }) {
  try {
    const response = yield postRequest('video_reels', payload, multipartFormHeaders);
    if (response?.status >= 200 && response?.status < 300) {
      const refreshedReelVideos = yield getRequest('video_reels/admin/all');
      yield put(
        successReelVideo({
          data: refreshedReelVideos?.status === 200 ? refreshedReelVideos?.data : [],
          action: 'add',
        })
      );
    } else {
      yield put(failedReelVideo(response));
      toast(getErrorMessage(response, 'Unable to add reel video.'));
    }
  } catch (error) {
    console.log(error);
    yield put(failedReelVideo(error));
    toast(getErrorMessage(error, 'Unable to add reel video.'));
  }
}

function* updateReelVideoFun({ payload }) {
  try {
    const response = yield patchRequest(`video_reels/${payload.id}`, payload.data, multipartFormHeaders);
    if (response?.status == 200) {
      const refreshedReelVideos = yield getRequest('video_reels/admin/all');
      yield put(
        successReelVideo({
          data: refreshedReelVideos?.status === 200 ? refreshedReelVideos?.data : [],
          action: 'update',
        })
      );
    } else {
      yield put(failedReelVideo(response));
      toast(getErrorMessage(response, 'Unable to update reel video.'));
    }
  } catch (error) {
    console.log(error);
    yield put(failedReelVideo(error));
    toast(getErrorMessage(error, 'Unable to update reel video.'));
  }
}

function* removeReelVideoFun({ payload }) {
  try {
    const response = yield deleteRequest(`video_reels/${payload}`);
    if (response?.status == 200) {
      const refreshedReelVideos = yield getRequest('video_reels/admin/all');
      yield put(
        successReelVideo({
          data: refreshedReelVideos?.status === 200 ? refreshedReelVideos?.data : [],
          action: 'remove',
        })
      );
    } else {
      yield put(failedReelVideo(response));
      toast(getErrorMessage(response, 'Unable to delete reel video.'));
    }
  } catch (error) {
    console.log(error);
    yield put(failedReelVideo(error));
    toast(getErrorMessage(error, 'Unable to delete reel video.'));
  }
}

// Text Testimonial Functions
function* getTextTestimonialFun() {
  try {
    const response = yield getRequest('text_testimonials/admin/all');
    if (response?.status == 200) {
      yield put(successTextTestimonial({ data: response?.data, action: 'fetchList' }));
    } else {
      yield put(failedTextTestimonial(response));
    }
  } catch (error) {
    console.log(error);
    yield put(failedTextTestimonial(error));
    toast(getErrorMessage(error, 'Unable to fetch text testimonials.'));
  }
}

function* getOneTextTestimonialFun({ payload }) {
  try {
    const response = yield getRequest(`text_testimonials/one/${payload}`);
    if (response?.status == 200) {
      yield put(successOneTextTestimonial({ data: response?.data, action: 'fetchOne' }));
    } else {
      yield put(failedTextTestimonial(response));
    }
  } catch (error) {
    console.log(error);
    yield put(failedTextTestimonial(error));
    toast(getErrorMessage(error, 'Unable to fetch testimonial details.'));
  }
}

function* addTextTestimonialFun({ payload }) {
  try {
    const response = yield postRequest('text_testimonials', payload, multipartFormHeaders);
    if (response?.status >= 200 && response?.status < 300) {
      const refreshedTestimonials = yield getRequest('text_testimonials/admin/all');
      yield put(
        successTextTestimonial({
          data: refreshedTestimonials?.status === 200 ? refreshedTestimonials?.data : [],
          action: 'add',
        })
      );
    } else {
      yield put(failedTextTestimonial(response));
      toast(getErrorMessage(response, 'Unable to add text testimonial.'));
    }
  } catch (error) {
    console.log(error);
    yield put(failedTextTestimonial(error));
    toast(getErrorMessage(error, 'Unable to add text testimonial.'));
  }
}

function* updateTextTestimonialFun({ payload }) {
  try {
    const response = yield patchRequest(`text_testimonials/${payload.id}`, payload.data, multipartFormHeaders);
    if (response?.status == 200) {
      const refreshedTestimonials = yield getRequest('text_testimonials/admin/all');
      yield put(
        successTextTestimonial({
          data: refreshedTestimonials?.status === 200 ? refreshedTestimonials?.data : [],
          action: 'update',
        })
      );
    } else {
      yield put(failedTextTestimonial(response));
      toast(getErrorMessage(response, 'Unable to update text testimonial.'));
    }
  } catch (error) {
    console.log(error);
    yield put(failedTextTestimonial(error));
    toast(getErrorMessage(error, 'Unable to update text testimonial.'));
  }
}

function* removeTextTestimonialFun({ payload }) {
  try {
    const response = yield deleteRequest(`text_testimonials/${payload}`);
    if (response?.status == 200) {
      const refreshedTestimonials = yield getRequest('text_testimonials/admin/all');
      yield put(
        successTextTestimonial({
          data: refreshedTestimonials?.status === 200 ? refreshedTestimonials?.data : [],
          action: 'remove',
        })
      );
    } else {
      yield put(failedTextTestimonial(response));
      toast(getErrorMessage(response, 'Unable to delete text testimonial.'));
    }
  } catch (error) {
    console.log(error);
    yield put(failedTextTestimonial(error));
    toast(getErrorMessage(error, 'Unable to delete text testimonial.'));
  }
}
// Enquire
function* getEnquireFun({ payload }) {
  try {
    const response = yield getRequest('enquire', payload, payload.header);
    if (response?.status == 200) {
      yield put(successEnquire(response?.data));
    } else {
      yield put(failedEnquire(response));
    }
  } catch (error) {
    console.log(error)
    toast('resposnse.message')
  }
}

function* removeEnquireFun({ payload }) {
  try {
    const response = yield deleteRequest(`enquire/${payload}`);
    if (response?.status == 200) {
      const response = yield getRequest('enquire', payload);
      yield put(successEnquire(response?.data));
    } else {
      yield put(failedEnquire(response));
    }
  } catch (error) {
    console.log(error)
    toast('resposnse.message')
  }
}

function* getCareerFun({ payload }) {
  try {
    const response = yield getRequest('career', payload);
    if (response?.status == 200) {
      yield put(successCareer(response?.data));
    } else {
      yield put(failedCareer(response));
    }
  } catch (error) {
    console.log(error)
    toast('resposnse.message')
  }
}

function* removeCareerFun({ payload }) {
  try {
    const response = yield deleteRequest(`career/${payload}`);
    if (response?.status == 200) {
      const response = yield getRequest('career', payload);
      yield put(success(response?.data));
    } else {
      yield put(failedCareer(response));
    }
  } catch (error) {
    console.log(error)
    toast('resposnse.message')
  }
}



//Banner Start
function* getBannerFun() {
  try {
    const response = yield getRequest('banner');
    if (response?.status == 200) {
      yield put(successBanner(response?.data));
    } else {
      yield put(failedContactUs(response));
    }
  } catch (error) {
    console.log(error)
    toast('resposnse.message')
  }
}

function* getOneBannerFun({ payload }) {
  try {
    const response = yield getRequest(`banner/one/${payload}`);
    if (response?.status == 200) {
      yield put(successBanner(response?.data));
    } else {
      yield put(failedContactUs(response));
    }
  } catch (error) {
    console.log(error)
    toast('resposnse.message')
  }
}

function* removeBannerFun({ payload }) {
  try {
    const response = yield deleteRequest(`banner/${payload}`);
    if (response?.status == 200) {
      const response = yield getRequest('banner', payload);
      yield put(successBanner(response?.data));
    } else {
      yield put(failedContactUs(response));
    }
  } catch (error) {
    console.log(error)
    toast('resposnse.message')
  }
}

function* addBannerFun({ payload }) {
  try {
    const response = yield postRequest(`banner`, payload);
    if (response?.status == 200) {
      yield put(successBanner(response?.data));
    } else {
      yield put(failedContactUs(response));
    }
  } catch (error) {
    console.log(error)
    toast('resposnse.message')
  }
}

function* updateBannerFun({ payload }) {
  try {
    const response = yield patchRequest(`banner/${payload.id}`, payload.data);
    if (response?.status == 200) {
      yield put(successBanner(response?.data));
    } else {
      yield put(failedContactUs(response));
    }
  } catch (error) {
    console.log(error)
    toast('resposnse.message')
  }
}

//Banner End 


//Ourteam Start
function* getOurteamFun() {
  try {
    const response = yield getRequest('ourteam');
    if (response?.status == 200) {
      yield put(successOurteam(response?.data));
    } else {
      yield put(failedOurteam(response));
    }
  } catch (error) {
    console.log(error)
    toast('resposnse.message')
  }
}

function* getOneOurteamFun({ payload }) {
  try {
    const response = yield getRequest(`ourteam/one/${payload}`);
    if (response?.status == 200) {
      yield put(successOurteam(response?.data));
    } else {
      yield put(failedOurteam(response));
    }
  } catch (error) {
    console.log(error)
    toast('resposnse.message')
  }
}

function* removeOurteamFun({ payload }) {
  try {
    const response = yield deleteRequest(`ourteam/${payload}`);
    if (response?.status == 200) {
      const response = yield getRequest('ourteam', payload);
      yield put(successOurteam(response?.data));
    } else {
      yield put(failedOurteam(response));
    }
  } catch (error) {
    console.log(error)
    toast('resposnse.message')
  }
}

function* addOurteamFun({ payload }) {
  try {
    const response = yield postRequest(`ourteam`, payload);
    if (response?.status == 200) {
      yield put(successOurteam(response?.data));
    } else {
      yield put(failedOurteam(response));
    }
  } catch (error) {
    console.log(error)
    toast('resposnse.message')
  }
}

function* updateOurteamFun({ payload }) {
  try {
    let header = {
      'Content-Type': 'multipart/form-data'
    }
    const response = yield patchRequest(`ourteam/${payload.id}`, payload.data, header);
    if (response?.status == 200) {
      yield put(successOurteam(response?.data));
    } else {
      yield put(failedOurteam(response));
    }
  } catch (error) {
    console.log(error)
    toast('resposnse.message')
  }
}

//Ourteam End 


// customer start
function* addCustomerFun({ payload }) {
  try {
    const response = yield postRequest(`customer`, payload);
    if (response?.status == 200) {
      yield put(successCustomer(response?.data));
    } else {
      yield put(failedOurteam(response));
    }
  } catch (error) {
    console.log(error)
    toast('resposnse.message')
  }
}


function* getCustomerFun() {
  try {
    const response = yield getRequest('customer');
    if (response?.status == 200) {
      yield put(successCustomer(response?.data));
    } else {
      yield put(failedOurteam(response));
    }
  } catch (error) {
    console.log(error)
    toast('resposnse.message')
  }
}

function* removeCustomerFun({ payload }) {
  try {
    const response = yield deleteRequest(`customer/${payload}`);
    if (response?.status == 200) {
      const response = yield getRequest('customer', payload);
      yield put(successCustomer(response?.data));
    } else {
      yield put(failedOurteam(response));
    }
  } catch (error) {
    console.log(error)
    toast('resposnse.message')
  }
}

function* getOneCustomerFun({ payload }) {
  try {
    const response = yield getRequest(`customer/one/${payload}`);
    if (response?.status == 200) {
      yield put(successCustomer(response?.data));
    } else {
      yield put(failedOurteam(response));
    }
  } catch (error) {
    console.log(error)
    toast('resposnse.message')
  }
}

function* updateCustomerFun({ payload }) {
  try {
    let header = {
      'Content-Type': 'multipart/form-data'
    }
    const response = yield patchRequest(`customer/${payload.id}`, payload.data, header);
    if (response?.status == 200) {
      yield put(successCustomer(response?.data));
    } else {
      yield put(failedOurteam(response));
    }
  } catch (error) {
    console.log(error)
    toast('resposnse.message')
  }
}

function* searchByMobileFun({ payload }) {
  try {
    const response = yield getRequest(`customer/search?name=${payload}`);
    if (response?.status == 200) {
      yield put(successCustomer(response?.data));
    } else {
      yield put(failedContactUs(response));
    }
  } catch (error) {
    console.log(error)
    toast('resposnse.message')
  }
}

// customer end

// order list DB start
function* addOrderListDBFun({ payload }) {
  try {
    const response = yield postRequest(`order`, payload);
    if (response?.status >= 200 && response?.status < 300) {
      const refreshedOrders = yield getRequest('order');

      if (refreshedOrders?.status === 200) {
        yield put(successOrderListDB(refreshedOrders?.data));
      } else {
        yield put(successOrderListDB(response?.data));
      }
    } else {
      yield put(failedOrderListDB(response));
    }
  } catch (error) {
    console.log(error)
    yield put(failedOrderListDB(error));
    toast(error?.message || error?.data?.message || 'Unable to create order')
  }
}

function* getOrderListDBFun() {
  try {
    const response = yield getRequest('order');
    if (response?.status == 200) {
      yield put(successOrderListDB(response?.data));
    } else {
      yield put(failedOrderListDB(response));
    }
  } catch (error) {
    console.log(error)
    toast('resposnse.message')
  }
}

function* getOrderDeatilsDBFun({payload}) {
  try {
    const response = yield getRequest(`order/order_details/${payload}`);
    if (response?.status == 200) {
      yield put(successOrderListDB(response?.data));
    } else {
      yield put(failedOrderListDB(response));
    }
  } catch (error) {
    console.log(error)
    toast('resposnse.message')
  }
}

// Fetch Appointments
function* getAppointmentFun({ payload }) {
  try {
    const response = yield getRequest('appointments', payload);
    if (response?.status == 200) {
      yield put(successAppointment(response?.data));
    } else {
      yield put(failedAppointment(response?.data));
      toast(response?.data?.message || 'Failed to fetch appointments');
    }
  } catch (error) {
    console.log(error);
    toast(error.response?.data?.message || error.message);
  }
}

// Fetch Dashboard Data
function* getDashboardDataaFun({ payload }) {
  try {
    const response = yield getRequest('dashboard', payload);
    if (response?.status == 200) {
      yield put(successAppointment(response?.data));
    } else {
      yield put(failedAppointment(response?.data));
      toast(response?.data?.message || 'Failed to fetch dashboard data');
    }
  } catch (error) {
    console.log(error);
    toast(error.response?.data?.message || error.message);
  }
}

// Remove Appointment
function* removeAppointmentFun({ payload }) {
  try {
    if (!payload) {
      throw new Error('Appointment ID is missing');
    }
    const deleteResponse = yield deleteRequest(`appointments/${payload}`);
    if (deleteResponse?.status >= 200 && deleteResponse?.status < 300) {
      // console.log('lllllllll', deleteResponse)
      yield getAppointmentFun({payload})
      toast('Appointment deleted successfully');
    } else {
      // If delete failed, dispatch failure action and show the error toast
      yield put(failedAppointment(deleteResponse?.data));
      toast(deleteResponse?.data?.message || 'Failed to delete appointment');
    }

  } catch (error) {
    console.log(error);
    toast(error.response?.data?.message || error.message);
  }
}

// function* removeAppointmentFun({ payload }) {
//   try {
//     const deleteResponse = yield deleteRequest(`appointments/${payload}`);
//     if (deleteResponse?.status == 200) {
//       const appointmentsResponse = yield getRequest('appointments');
//       yield put(successAppointment(appointmentsResponse?.data));
//     } else {
//       yield put(failedAppointment(deleteResponse?.data));
//       toast(deleteResponse?.data?.message || 'Failed to delete appointment');
//     }
//   } catch (error) {
//     console.log(error);
//     toast(error.response?.data?.message || error.message);
//   }
// }



// appointemnt
// order list db end 


// Generator function
export function* watchGetUser() {
  yield takeLatest(signin, signinUser);
  yield takeLatest(signup, signupUser);

  // contact us
  yield takeLatest(getContactUs, getContactUsFun);
  yield takeLatest(getDashboardData, getDashboardDataFun);
  yield takeLatest(removeContactUs, removeContactUsFun);

 // appointemnt
  yield takeLatest(getAppointment, getAppointmentFun);
  yield takeLatest(getDashboardDataa, getDashboardDataaFun);
  yield takeLatest(removeAppointment, removeAppointmentFun);

  //Enquire
  yield takeLatest(getEnquire, getEnquireFun);
  yield takeLatest(removeEnquire, removeEnquireFun);

  yield takeLatest(addProduct, addProductFun);
  yield takeLatest(getProduct, getProductFun);
  yield takeLatest(getOneProduct, getOneProductFun);
  yield takeLatest(searchProductByName, searchProductByNameFun);
  yield takeLatest(removeProduct, removeProductFun);
  yield takeLatest(updateProduct, updateProductFun);

  // medicine
  yield takeLatest(addMedicine, addMedicineFun);
  yield takeLatest(getMedicine, getMedicineFun);
  yield takeLatest(getOneMedicine, getOneMedicineFun);
  yield takeLatest(removeMedicine, removeMedicineFun);
  yield takeLatest(updateMedicine, updateMedicineFun);

  // plan
  yield takeLatest(addPlan, addPlanFun);
  yield takeLatest(getPlan, getPlanFun);
  yield takeLatest(getOnePlan, getOnePlanFun);
  yield takeLatest(removePlan, removePlanFun);
  yield takeLatest(updatePlan, updatePlanFun);

  // plan medicine
  yield takeLatest(addPlanMedicine, addPlanMedicineFun);
  yield takeLatest(getPlanMedicine, getPlanMedicineFun);
  yield takeLatest(getOnePlanMedicine, getOnePlanMedicineFun);
  yield takeLatest(removePlanMedicine, removePlanMedicineFun);
  yield takeLatest(updatePlanMedicine, updatePlanMedicineFun);

  //gallery
  yield takeLatest(addGallery, addGalleryFun);
  yield takeLatest(getGallery, getGalleryFun);
  yield takeLatest(removeGallery, removeGalleryFun);
  yield takeLatest(getOneGallery, getOneGalleryFun);
  yield takeLatest(updateGallery, updateGalleryFun);

   //media
   yield takeLatest(addMedia, addMediaFun);
   yield takeLatest(getMedia, getMediaFun);
   yield takeLatest(removeMedia, removeMediaFun);
   yield takeLatest(getOneMedia, getOneMediaFun);
   yield takeLatest(updateMedia, updateMediaFun);

   // reel video
   yield takeLatest(addReelVideo, addReelVideoFun);
   yield takeLatest(getReelVideo, getReelVideoFun);
   yield takeLatest(removeReelVideo, removeReelVideoFun);
   yield takeLatest(getOneReelVideo, getOneReelVideoFun);
   yield takeLatest(updateReelVideo, updateReelVideoFun);

   // text testimonial
   yield takeLatest(addTextTestimonial, addTextTestimonialFun);
   yield takeLatest(getTextTestimonial, getTextTestimonialFun);
   yield takeLatest(removeTextTestimonial, removeTextTestimonialFun);
   yield takeLatest(getOneTextTestimonial, getOneTextTestimonialFun);
   yield takeLatest(updateTextTestimonial, updateTextTestimonialFun);

  //Banner
  yield takeLatest(addBanner, addBannerFun);
  yield takeLatest(getBanner, getBannerFun);
  yield takeLatest(removeBanner, removeBannerFun);
  yield takeLatest(getOneBanner, getOneBannerFun);
  yield takeLatest(updateBanner, updateBannerFun);

  //Our Team
  yield takeLatest(addOurteam, addOurteamFun);
  yield takeLatest(getOurteam, getOurteamFun);
  yield takeLatest(removeOurteam, removeOurteamFun);
  yield takeLatest(getOneOurteam, getOneOurteamFun);
  yield takeLatest(updateOurteam, updateOurteamFun);

  // Career 
  yield takeLatest(getCareer, getCareerFun);
  yield takeLatest(removeCareer, removeCareerFun);

  //Customer
  yield takeLatest(addCustomer, addCustomerFun);
  yield takeLatest(getCustomer, getCustomerFun);
  yield takeLatest(removeCustomer, removeCustomerFun);
  yield takeLatest(getOneCustomer, getOneCustomerFun);
  yield takeLatest(updateCustomer, updateCustomerFun);
  yield takeLatest(searchByMobile, searchByMobileFun);

  yield takeLatest(getCareer, getCareerFun);
  yield takeLatest(removeCareer, removeCareerFun);

  // order DB
  yield takeLatest(addOrderListDB, addOrderListDBFun);
  yield takeLatest(getOrderListDB, getOrderListDBFun);
  yield takeLatest(getOrderDeatilsDB, getOrderDeatilsDBFun);
  yield takeLatest(updateOrderListDB, updateOrderAPI);

  

}
